/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    @Serenity.Decorators.registerClass()
    export class MarketExchangeGrid extends SiteEntityGrid<MarketExchangeRow, any> {
        protected getColumnsKey() { return 'Data.MarketExchange'; }
        protected getDialogType() { return MarketExchangeDialog; }
        protected getIdProperty() { return MarketExchangeRow.idProperty; }
        protected getLocalTextPrefix() { return MarketExchangeRow.localTextPrefix; }
        protected getService() { return MarketExchangeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}